import { Permissions, usePermission } from 'src/rbac';

/**
 * May this user create an Episode of Care? Drives the "Add New Episode of Care" button's
 * disabled state on the patient's Episode-of-Care tab.
 *
 * Migrated (Segment B) from the legacy `permissionData.includes('Create Episode Of Care')`
 * display-name check to the instrumented `Permissions.CREATE_EOC` scopeKey. The scopeKey's
 * catalog display name and the paths.ts string still match each other (parity-verified); both
 * are now "Create Episode of Care" after the THIN-8081 casing fix in catalog 5.20.0. Gating on
 * the scopeKey means the rename cannot reach this check; it also emits RUM telemetry.
 */
export function useCreateEocGate(): boolean {
  return usePermission(Permissions.CREATE_EOC);
}
